import axios from './api';

export default function walletTransaction(params) {
  return new Promise((resolve, reject) => {
    axios.get('/wallet/walletTransaction', {
      params: {
        page: params.currentPage,
        size: params.pageSize,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    })
    .then((res) => {
      resolve(res.data);
    })
    .catch((error) => {
      reject(error);
    });
  })
};